import styled, { keyframes } from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import { LoadedDoctorDetailViewModel } from '@/components/templates/doctor/detail/useDoctorDetailViewModel';
import { cn } from '@/utils/style';

interface Props {
  viewModel: LoadedDoctorDetailViewModel;
}

const DoctorProfile = ({ viewModel }: Props) => {
  if (!viewModel.doctorDetail) {
    return null;
  }
  return (
    <Wrapper>
      <DoctorProfileImage
        style={{
          backgroundImage: `url("${viewModel.doctorDetail.doctor.profileImageUrl}")`,
        }}
      />
      <DoctorDescription>
        <DoctorAndHospitalName>
          <HospitalName>{viewModel.doctorDetail.hospital.name}</HospitalName>
          <div className='flex w-full items-center justify-between'>
            <DoctorName>
              {viewModel.getDoctorDisplayName(
                viewModel.doctorDetail.doctor.name,
                viewModel.doctorDetail.doctor.medicineType
              )}
            </DoctorName>
            <MaterialIcon
              className={cn(['cursor-pointer', viewModel.isFamilyDoctor ? 'text-red-600' : 'text-gray-100'])}
              name='favorite'
              filled={true}
              size={24}
              onClick={() => {
                viewModel.handleUpdateFamilyDoctor([viewModel.doctorDetail.doctor.id]);
              }}
            />
          </div>
        </DoctorAndHospitalName>
      </DoctorDescription>
    </Wrapper>
  );
};

export default DoctorProfile;

const Wrapper = styled.div`
  align-items: center;
`;

const DoctorDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px 24px 0;
`;

const DoctorAndHospitalName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
`;

const HospitalName = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI14M};
    color: ${theme.color.gray400};
  `}
`;

const DoctorName = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI22SB};
    color: ${theme.color.gray900};
  `}
`;

const animationKeyFrames = keyframes`
  0% {
      opacity: 0;
  }

  100% { opacity: 1}
`;

const DoctorProfileImage = styled.div`
  height: 240px;
  border-radius: 40px;
  background-position: center;
  background-size: contain;

  animation: 0.5s ${animationKeyFrames} ease-in-out;
`;
